import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CarouselModule } from "ngx-owl-carousel-o";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InlineSVGModule } from "ng-inline-svg-2";
import { LeaderboardComponent } from "./components/leaderboard/leaderboard.component";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { FGBSharedModule } from "@fgb/portal-component-library/src/lib/shared";
import { ShortLongDescriptionModule } from "@fgb/portal-component-library/src/lib/shared/short-long-description";
import { ErrorsModule } from "@fgb/portal-component-library/src/lib/shared/errors";
import { FilterByModule } from "@fgb/portal-component-library/src/lib/shared/filter-by";
import { OfferSearchBarModule } from "@fgb/portal-component-library/src/lib/club/offer-search-bar";
import { LeaderboardMonthlyComponent } from "./components/leaderboard-monthly/leaderboard-monthly.component";
import { CountdownModule } from "@fgb/portal-component-library/src/lib/shared/countdown";
import { TimeSinceModule } from "@fgb/portal-component-library/src/lib/shared/time-since";
import { NotificationModule } from "@fgb/portal-component-library/src/lib/club/notification";
import { DirectivesModule } from "@fgb/portal-component-library/src/lib/directives";
import { NotificationButtonComponent } from "./components/notification/notification-button/notification-button.component";
import { TabComponent } from "./components/games-tab/tab.component";

@NgModule({
  declarations: [
    LeaderboardComponent,
    LeaderboardMonthlyComponent,
    NotificationButtonComponent,
  ],
  imports: [
    NgbModule,
    SharedModule,
    CommonModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ShortLongDescriptionModule,
    OfferSearchBarModule,
    ErrorsModule,
    FilterByModule,
    CountdownModule,
    TimeSinceModule,
    NotificationModule,
    DirectivesModule,
    ToastrModule.forRoot(),
    InlineSVGModule.forRoot(),
    FGBSharedModule,
    RouterModule,
    TabComponent,
  ],
  exports: [
    LeaderboardComponent,
    LeaderboardMonthlyComponent,
    NotificationButtonComponent,
  ],
})
export class ClubModule {}
